import React, { useEffect, useState, useRef } from "react";
import { Box, CircularProgress, Zoom } from '@mui/material';
import config from 'config'
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";

const defaultURI = `${config.apiGateway.URL}/${config.apiGateway.DEFAULT_VERSION}`;

export default function LoaderAnimation({timeout, centerAtPage=false}) {
  const [zoomIn, setZoomIn] = useState(true);
  const zoomInRef = useRef(zoomIn);
  zoomInRef.current = zoomIn;

  const boxStyle={
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginTop: '-50px',
      marginLeft: '-50px',
      width: '100px',
      height: '100px'
  }

  const flexStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignContent: 'center',
    margin:'5px'
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      setZoomIn(!zoomInRef.current);
    },500);

    return () => clearInterval(intervalId);
  },[])

  return (
    <Box style={(centerAtPage ? boxStyle : flexStyle)}>
      <div style={{position: 'relative', width: '100px', height: '100px'}}>
        <Zoom
          in={zoomInRef.current}
        >
          <img style={{position: 'absolute', width: '100%', margin:'auto', inset: '0px'}} src={`${defaultURI}/Me/TenantLogo/sqr`} alt="logo" id="small-logo" />
        </Zoom>
        <div style={{position: 'absolute'}}>
          <CircularProgress size={100} />
        </div>
      </div>
    </Box>
  );
}
